module.exports = __webpack_public_path__ + "static/EU4BLogo-5ecb7c28daab9a0ce42ce94ac1b198ed.png";